<script setup lang="ts">
import { Slider } from '@/components/ui/slider'
import { cn } from '@/lib/utils'

const props = defineProps<{ limit: number, min?: number }>()
const currency = useCurrency()
const modelValue = defineModel({
  type: Number,
})
const value = ref()
value.value = [modelValue.value ?? props.limit]
watch(
  () => value.value[0],
  (newValue) => {
    modelValue.value = newValue
  },
  { immediate: true },
)
watch(modelValue, (newValue) => {
  value.value = [newValue ?? props.limit]
}, { immediate: true })
</script>

<template>
  <div class="w-full relative">
    <Slider v-model="value" :max="props.limit" :step="500" :min="3000" class="transition-all duration-300" />
    <div class="flex items-center justify-between w-full mt-2 h-4">
      <div class="text-xs text-muted-foreground">
        {{ currency.format(props.min ?? 3000) }} ₽
      </div>
      <div class=" text-xs text-muted-foreground">
        {{ currency.format(props.limit) }} ₽
      </div>
    </div>
  </div>
</template>

<style scoped></style>
